import { asText, Content, isFilled } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { Box, Heading, Typography } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { HeadlineBreadcrumbs } from '@/components/Display/HeadlineBreadcrumbs';
import { LastReviewedHeadline } from '@/components/Display/LastReviewedHeadline';

type HeroContentProps = {
  slice: Content.PageHeroHeadlineSlice;
};

export const HeroContent = ({ slice }: HeroContentProps) => {
  const { primary } = slice;
  const { title, lede, caption, breadcrumbs, last_reviewed } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" className="hero__content">
      <Box component="div" addFlow>
        <HeadlineBreadcrumbs breadcrumbs={breadcrumbs} />

        <Heading component="h1" addHeroTitle className="t-primary">
          {asText(title)}
        </Heading>

        {isFilled.richText(lede) && (
          <Typography component="p" className="lede">
            {asText(lede)}
          </Typography>
        )}

        {isFilled.richText(caption) && (
          <RichText
            content={caption}
            variant="default"
            websiteUrl={WebsiteUrl}
          />
        )}

        <LastReviewedHeadline lastReviewed={last_reviewed} />
      </Box>
    </Box>
  );
};
